import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { LocalNotifications } from "@capacitor/local-notifications";
import { createQuickOrder } from "@/api/lst";
import { payOrderForPlatform } from "@/utils/orderPayJq18";
import { enqueueHallTradeEvent } from "@/utils/hallTradeQueue";
import { ensureKmsOperationAllowed } from "@/utils/appSecurity";
const state = {
    running: false,
    stopping: false,
    logs: [],
    successCount: 0,
    failCount: 0,
    config: null,
    listeners: new Set()
};
const log = (msg, type = "info") => {
    const item = { time: (new Date()).toLocaleTimeString(), msg, type };
    state.logs.push(item);
    if (state.logs.length > 200)
        state.logs.shift();
    state.listeners.forEach((fn) => fn(item));
};
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const notify = async (title, body) => {
    if (!Capacitor.isNativePlatform())
        return;
    try {
        await LocalNotifications.schedule({
            notifications: [{
                    title,
                    body,
                    id: Date.now(),
                    schedule: { at: new Date(Date.now() + 100) },
                    sound: "default"
                }]
        });
    }
    catch (e) {
    }
};
export const startPurchase = async (config) => {
    if (state.running) {
        log("\u4EFB\u52A1\u5DF2\u5728\u8FD0\u884C\u4E2D", "warning");
        return false;
    }
    const gate = await ensureKmsOperationAllowed("purchase");
    if (!gate.ok) {
        log(gate.message, "error");
        return false;
    }
    const { token, phone, albumId, albumName, maxPrice, quantity, payPassword } = config;
    state.running = true;
    state.stopping = false;
    state.logs = [];
    state.successCount = 0;
    state.failCount = 0;
    state.config = config;
    log(`\u5F00\u59CB\u62A2\u8D2D: ${albumName || albumId}`);
    log(`\u76EE\u6807: ${quantity}\u4E2A, \u6700\u9AD8\u4EF7: \xA5${maxPrice}`);
    if (Capacitor.isNativePlatform()) {
        try {
            await LocalNotifications.requestPermissions();
        }
        catch (e) {
        }
        App.addListener("appStateChange", ({ isActive }) => {
            if (!isActive && state.running) {
                log("\u26A0\uFE0F APP\u8FDB\u5165\u540E\u53F0\uFF0C\u4EFB\u52A1\u7EE7\u7EED\u8FD0\u884C", "warning");
                notify("\u62A2\u8D2D\u8FD0\u884C\u4E2D", `\u6B63\u5728\u62A2\u8D2D ${albumName || albumId}`);
            }
        });
    }
    let bought = 0;
    let attempt = 0;
    const target = parseInt(quantity);
    while (bought < target && !state.stopping) {
        attempt++;
        try {
            const orderRes = await createQuickOrder(token, phone, albumId, maxPrice);
            if (orderRes.message === "success" && orderRes.data?.orderId) {
                log(`\u2713 \u9501\u5355\u6210\u529F #${attempt}`, "success");
                const payRes = await payOrderForPlatform(token, phone, orderRes.data.orderId, payPassword);
                if (payRes._paySettled) {
                    bought++;
                    state.successCount++;
                    log(`\u2713 \u652F\u4ED8\u6210\u529F! (${bought}/${target})`, "success");
                    void enqueueHallTradeEvent({
                        side: "buy",
                        orderNo: String(orderRes.data.orderId),
                        amountYuan: Number(maxPrice),
                        tradeTimeMs: Date.now(),
                        albumId: String(albumId),
                        albumName: String(albumName || "")
                    });
                    await notify("\u62A2\u8D2D\u6210\u529F", `\u5DF2\u8D2D\u4E70 ${bought}/${target} \u4E2A`);
                }
                else if (payRes._yeepayOpened) {
                    log(`\u6613\u5B9D/\u8BA2\u5355\u9875\u5DF2\u6253\u5F00\uFF0C\u8BF7\u5728\u6D4F\u89C8\u5668\u5B8C\u6210\u652F\u4ED8\u540E\u518D\u8BD5\u6216\u67E5\u770B\u8BA2\u5355`, "warning");
                }
                else {
                    state.failCount++;
                    log(`\u2717 \u652F\u4ED8\u5931\u8D25: ${payRes._payError || payRes.message || "\u8BA2\u5355\u4ECD\u4E3A\u5F85\u652F\u4ED8"}`, "error");
                }
            }
            else {
                if (orderRes.code === 13003) {
                    log(`\u6682\u65E0\u5E93\u5B58\uFF0C\u7EE7\u7EED\u76D1\u63A7... #${attempt}`, "warning");
                }
                else {
                    log(`\u9501\u5355\u5931\u8D25: ${orderRes.message} #${attempt}`, "error");
                }
            }
        }
        catch (e) {
            log(`\u5F02\u5E38: ${e.message}`, "error");
        }
        await sleep(300 + Math.random() * 200);
    }
    state.running = false;
    if (state.stopping) {
        log("\u4EFB\u52A1\u5DF2\u505C\u6B62", "warning");
    }
    else {
        log(`\u4EFB\u52A1\u5B8C\u6210! \u6210\u529F:${state.successCount} \u5931\u8D25:${state.failCount}`, "info");
    }
    await notify("\u62A2\u8D2D\u4EFB\u52A1\u7ED3\u675F", `\u6210\u529F:${state.successCount} \u5931\u8D25:${state.failCount}`);
    return true;
};
export const stopPurchase = () => {
    if (state.running) {
        state.stopping = true;
        log("\u6B63\u5728\u505C\u6B62...", "warning");
        return true;
    }
    return false;
};
export const getState = () => ({
    running: state.running,
    logs: [...state.logs],
    successCount: state.successCount,
    failCount: state.failCount
});
export const onLog = (fn) => {
    state.listeners.add(fn);
    return () => state.listeners.delete(fn);
};
export default { startPurchase, stopPurchase, getState, onLog };
